<template>
  <section id="card-text-alignment">
    <itens-modal ref="itenModal"/>
    <b-card >
      <b-table
          :striped="true"
          :bordered="true"
          :hover="true"
          :responsive="true"
          table-variant="secondary"
          :per-page="perPage"
          :current-page="currentPage"
          :fields="fields"
          :items="items"
          small
      >
        <!-- A virtual column -->
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>

        <template #cell(qtdItem)="data">
          <span>{{ parseInt(data.item.qtdItem) }}</span>
        </template>

        <template #cell(action)="data">
          <div
              class="d-flex"
              style="gap:5px"
          >
            <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                title="Detalhes item"
                variant="success"
                @click="abrirModal(data.item)"
            >
              <feather-icon icon="SearchIcon"/>
            </b-button>
            <!-- <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="primary"
                title="Produto"
            >
              <feather-icon icon="BoxIcon"/>
            </b-button> -->
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col sm="5" md="4" class="my-1">
          <b-form-group
              label="paginação"
              label-for="per-page-select"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
          >
            <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                size="sm"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="7" md="6" class="my-1">
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>

<script>
import { VBTooltip, BButton, BFormSelect } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { mapGetters } from 'vuex';
import ItensModal from '@/views/app/PTC/Pedidos/cardsDetalhePedido/ItensModal.vue';

export default {
  components: {
    ItensModal,
    BFormSelect,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      fields: [
        { key: 'sequenciaItem', label: 'Sequência' },
        { key: 'codItem', label: 'Item' },
        { key: 'descrItem', label: 'Descrição' },
        { key: 'qtdItem', label: 'Quantidade' },
        { key: 'vlrUnitario', label: 'Preço de Venda' },
        { key: 'vlrTotalItem', label: 'Valor Total' },
        { key: 'action', label: 'Ações' },

      ],
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
    };
  },
  methods: {
    abrirModal(item) {
      this.$refs.itenModal.abrirModal(item);
    },
  },

  computed: {
    ...mapGetters({
      items: 'PTC_PedidosClient/getItensPedido',
    }),
    // widthProgress() {
    //   return `width-${this.pedido.status}`
    // },
  },
};
</script>
<style scoped lang="scss">

</style>
